
<template>
  <div>
    <Head title="會員中心 - 回饋查詢" />
    <rebate-template title="會員中心">
      <template #header>回饋查詢</template>

      <main>
        <div class="flex flex-wrap justify-center md:justify-start">
          <div class="p-0 md:pb-4">
            <div class="rebates_box_full">
              <div>
                <template v-if="cv_type == 'cvt'">當期C.V.T.</template
                ><template v-else>當期C.V.</template>
              </div>
              <div class="text-2xl">
                <template v-if="cv_type == 'cvt'">{{
                  $page.props.current.cvt | commaFormat
                }}</template
                ><template v-else>{{
                  $page.props.current.cv | commaFormat
                }}</template>
              </div>
              <Link :href="route('user.rebates.list')">查看明細</Link>
            </div>
          </div>
          <div class="flex flex-col md:ml-5">
            <div class="rebates_box">
              <div>購物金</div>
              <div class="text-2xl">{{ $page.props.bonus | commaFormat }}</div>
              <div class="text-right text-sm">
                <Link :href="route('user.rebates.bonus')">查看明細</Link>
              </div>
            </div>
            <div class="rebates_box">
              <div>上期獎勵金</div>
              <div class="text-2xl">{{ $page.props.rebate | commaFormat }}</div>
              <div class="text-right text-sm">
                <Link :href="route('user.rebates.rebate')">查看明細</Link>
              </div>
            </div>
          </div>
        </div>
      </main>
    </rebate-template>
  </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import RebateTemplate from "./Shared/RebateTemplate";

export default {
  components: {
    RebateTemplate,
  },
  filters: {
    commaFormat: function (value) {
      return value
        .toString()
        .replace(
          /^(-?\d+?)((?:\d{3})+)(?=\.\d+$|$)/,
          function (all, pre, groupOf3Digital) {
            return pre + groupOf3Digital.replace(/\d{3}/g, ",$&");
          }
        );
    },
  },
  layout: Layout,
  computed: {
    cv_type() {
      if (
        this.$page.props.auth.user &&
        this.$page.props.auth.user.level == 1 &&
        !this.$page.props.auth.user.attributes?.degraded_at &&
        (this.$page.props.rules.regular?.cv?.checked ||
          this.$page.props.rules.regular?.referral?.checked)
      ) {
        // 一般會員
        if (this.$page.props.rules.regular?.cv?.referred) return "cvt";
      }

      if (
        this.$page.props.auth.user &&
        this.$page.props.auth.user.level == 2 &&
        (this.$page.props.rules.upgraded?.cv?.checked ||
          this.$page.props.rules.upgraded?.referral?.checked)
      ) {
        // 推廣會員
        if (this.$page.props.rules.upgraded?.cv?.referred) return "cvt";
      }

      if (
        this.$page.props.auth.user &&
        this.$page.props.auth.user.level == 1 &&
        this.$page.props.auth.user.attributes?.degraded_at &&
        (this.$page.props.rules.degraded?.cv?.checked ||
          this.$page.props.rules.degraded?.referral?.checked)
      ) {
        //一般會員升回推廣會員
        if (this.$page.props.rules.degraded?.cv?.referred) return "cvt";
      }

      return "cv";
    },
  },
  data() {
    return {
      //
    };
  },
};
</script>

<style lang="postcss">
.rebates_box_full {
  @apply flex justify-between flex-col border border-fh-gray-border p-5 m-2 w-52 h-52 md:h-full text-center;
}

.rebates_box {
  @apply flex justify-between flex-col border border-fh-gray-border p-5 m-2 w-52 h-52 text-center;
}
</style>